module.exports = __webpack_public_path__ + "static/img/platform-5.88939c77.png";